import "@/App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Science from "@/pages/Science";
import Research from "@/pages/Research";
import Training from "@/pages/Training";
import CourseDetail from "@/pages/CourseDetail";
import Platform from "@/pages/Platform";
import Sectors from "@/pages/Sectors";
import SectorDetail from "@/pages/SectorDetail";
import MapPage from "@/pages/Map";
import CaseStudies from "@/pages/CaseStudies";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Authors from "@/pages/Authors";
import AuthorDetail from "@/pages/AuthorDetail";
import Membership from "@/pages/Membership";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CourseLearn from "@/pages/CourseLearn";
import SubmitInsight from "@/pages/SubmitInsight";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/science", element: <Science /> },
      { path: "/research", element: <Research /> },
      { path: "/training", element: <Training /> },
      { path: "/training/:code", element: <CourseDetail /> },
      { path: "/platform", element: <Platform /> },
      { path: "/sectors", element: <Sectors /> },
      { path: "/sectors/:id", element: <SectorDetail /> },
      { path: "/map", element: <MapPage /> },
      { path: "/case-studies", element: <CaseStudies /> },
      { path: "/insights", element: <Insights /> },
      { path: "/insights/:slug", element: <InsightDetail /> },
      { path: "/authors", element: <Authors /> },
      { path: "/authors/:slug", element: <AuthorDetail /> },
      { path: "/membership", element: <Membership /> },
      { path: "/contact", element: <Contact /> },
      { path: "/login", element: <Login /> },
      { path: "/register", element: <Register /> },
      { path: "/checkout/success", element: <CheckoutSuccess /> },
      { path: "/insights/submit", element: <SubmitInsight /> },
      { path: "/dashboard", element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
      { path: "/dashboard/courses/:enrolmentId", element: <ProtectedRoute><CourseLearn /></ProtectedRoute> },
      { path: "/admin", element: <ProtectedRoute adminOnly><Admin /></ProtectedRoute> },
    ],
  },
]);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
